<template>
  <div class="set_wrap">
    <div class="card_list mt-20">
      <el-card class="box-card mt-20">
        <div slot="header" class="clearfix">
          <span>关注后自动回复 </span>
        </div>
        <div class="text item">
          <el-form ref="form" label-width="200px" label-position="left">
            <el-form-item label="自动回复：(随机发送):">
              <div v-if="keywordList.length!==0">
                <div class="form_list" v-for="(item, index) in keywordList" :key="index">{{index+1}}.{{item.response}}</div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-button @click="editkeyword()" size="small">编辑</el-button>
        </div>
      </el-card>
    </div>
    <editAutoReplyDialog :visible.sync="editautoreplydialog" v-if="editautoreplydialog"
                         @changeInint="changeInint" :editBody="editBody"></editAutoReplyDialog>
  </div>
</template>
<script>
  import api from "@/api.js";
  import editAutoReplyDialog from "@/components/dialog/editAutoReplyDialog.vue";

  export default {
    name: "analyticsOfficialReplyAfterFocus",
    components: {
      editAutoReplyDialog
    },
    data() {
      return {
        editautoreplydialog: false,
        keywordList: []
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        this.axios
            .post(api.accounts_attention, {})
            .then(response => {
              this.lock = true;
              if (response.data.code == 0) {
                this.keywordList = response.data.list
              } else {
              }
            })
            .catch(response => {
              this.lock = true;
            });
      },
      editkeyword() {
        this.editBody = this.keywordList;
        this.editautoreplydialog = true;
      },
      changeInint() {
        this.InitFn()
      }
    }
  };
</script>
